import { Libraries } from '@react-google-maps/api';
import { osName } from 'react-device-detect';
import { APP_ENV } from './env';

export * from './constants';
export * from './socials';
export * from './range';
export * from './skill-levels';
export * from './intersets';
export * from './locations';
export * from './events';
export * from './custom-host-colors';
export * from './app-links';
export * from './query-keys';
export * from './host-slides';
export * from './sitemaps';
export * from './robots.txt';
export * from './stripe-form.constants';
export * from './newrelic';
export * from './env';
export * from './features';
export * from './event-participants';

export const googleApiLibraries: Libraries = [
	'places',
	'geometry',
];

export const os = osName;

export enum OS_ENUM {
	Android = 'Android',
	iOS = 'iOS',
	MacOS = 'Mac OS',
	Unknown = 'Unknown'
}

export const isClient = typeof window !== 'undefined';

export const isTouch = isClient && "ontouchstart" in window;

export const isIframe = isClient && window.self !== window.top;

export const isSmsEnabled = !['local', 'dev'].includes(APP_ENV);

export const mainElemId = 'main-scroller';

export const checkoutFromSubmitButtonId = 'checkout-form-submit-button';
